import { render } from '@react-email/render'

import Activation from './templates/Activation'
import ActivationAdmin from './templates/ActivationAdmin'
import ResetPassword from './templates/ResetPassword'
import ResetPasswordAdmin from './templates/ResetPasswordAdmin'
import SendUsername from './templates/SendUsername'

// Create an async function to render all templates
const renderTemplates = async () => {
    const templates = {
        activation: {
            subject: `[${process.env.REACT_APP_NAME}] Your account has been created`,
            html: await render(<Activation/>, { pretty: true }),
            text: await render(<Activation/>, { plainText: true })
        }, 
        activationAdmin: {
            subject: `[${process.env.REACT_APP_NAME}] Your account has been reset by Admin`,
            html: await render(<ActivationAdmin/>, { pretty: true }),
            text: await render(<ActivationAdmin/>, { plainText: true })
        }, 
        resetPassword: {
            subject: `[${process.env.REACT_APP_NAME}] Password reset has been requested`,
            html: await render(<ResetPassword/>, { pretty: true }),
            text: await render(<ResetPassword/>, { plainText: true })
        }, 
        resetPasswordAdmin: {
            subject: `[${process.env.REACT_APP_NAME}] Password reset has been requested by Admin`,
            html: await render(<ResetPasswordAdmin/>, { pretty: true }),
            text: await render(<ResetPasswordAdmin/>, { plainText: true })
        }, 
        sendUsername: {
            subject: `[${process.env.REACT_APP_NAME}] Your Username`,
            html: await render(<SendUsername/>, { pretty: true }),
            text: await render(<SendUsername/>, { plainText: true })
        }, 
    }
    
    return templates
}

// Export the promise that resolves to the templates
export default renderTemplates()

